import { Component } from "react";

export default class withWatchMeta extends Component {
  componentDidMount() {
    const { meta } = this.props.quizN || {};
    const { quizNMetaWatch } = this.props;

    if (!meta) {
      quizNMetaWatch();
    }
  }

  render() {
    return false;
  }
}
